import React from 'react';
import { FadeIn } from './FadeIn';
import { Snowflake, Brain, ShieldCheck, Clock3, BedDouble } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Snowflake className="w-6 h-6" data-id="element-203" />,
    title: 'El Protocolo de Enfriamiento de 90 Minutos',
    desc: 'Para inducir el sueño profundo.'
  }, {
    icon: <Brain className="w-6 h-6" data-id="element-204" />,
    title: "La técnica de 'Vaciado de Cerebro'",
    desc: 'Para apagar el ruido mental antes de acostarte.'
  }, {
    icon: <ShieldCheck className="w-6 h-6" data-id="element-205" />,
    title: 'Guía de suplementación inteligente',
    desc: 'Qué funciona y qué es una estafa para mayores de 50.'
  }, {
    icon: <Clock3 className="w-6 h-6" data-id="element-206" />,
    title: 'El Plan de Rescate de las 3 AM',
    desc: 'Qué hacer exactamente si te despiertas a mitad de la noche para volver a dormir en minutos.'
  }, {
    icon: <BedDouble className="w-6 h-6" data-id="element-207" />,
    title: 'Auditoría de Dormitorio',
    desc: 'Los 6 cambios físicos que transformarán tu habitación en un santuario del descanso.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800" data-id="element-208">
      <div className="max-w-5xl mx-auto" data-id="element-209">
        <FadeIn data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-white" data-id="element-211">
            Qué obtendrás:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-213">
              <div className="bg-navy-900 p-8 rounded-2xl border border-navy-700 h-full hover:border-amber-500/50 transition-colors" data-id="element-214">
                <div className="w-12 h-12 bg-navy-800 rounded-xl flex items-center justify-center text-amber-500 mb-6" data-id="element-215">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-216">
                  {item.title}
                </h3>
                <p className="text-lavender-200" data-id="element-217">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}